import React,{useContext, useEffect} from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import styled from "styled-components";
import { buyTokenPopUpContext } from "../../context/buyTokenPopUpContext";
import { makeStyles } from "@mui/styles";


const DialogStyledUpdate = styled(Dialog)``;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -30px;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;

const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));

const NftNameConfirm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: center;
  ${(p) => {
    p.ConfirmPopup &&
      `
   justify-content: flex-start;
  `;
  }}
`;
const BuyPop = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 16px;
  font-weight: 600;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: capitalize;
  background-color: #171e22;
  padding: 25px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 35px;
  width: 170px;
  margin-top: 20px;
  cursor: pointer;
  &:hover {
  }
`;
const NftNameConfirmHead = styled.div`
  font-size: 32px;
  font-weight: 500;
  // text-align: center;
`;
const LowBalancePopUp = ({ message, currency,setIsStakeError,isStakeError }) => {
  const classes = useStyles();

  const { setIsBuyOpen, setPopUpCurrency } = useContext(buyTokenPopUpContext);
  useEffect(()=>{
    setPopUpCurrency(currency)
  })

  return (
    <>
      <DialogStyledUpdate
        open={isStakeError}
        onClose={() => {
          setIsStakeError(false);
          setIsBuyOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel
          onClick={() => {
            setIsStakeError(false);
            setIsBuyOpen(false);
          }}
          color="primary"
        >
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          <NftNameConfirm>
            <NftNameConfirmHead>{message}</NftNameConfirmHead>
            <BuyPop
              onClick={() => {
                setIsBuyOpen(true);
                setIsStakeError(false);
                setTimeout(() => {
                  setIsBuyOpen(false);
                }, 1000);
              }}
            >
              Click here to Buy
            </BuyPop>
          </NftNameConfirm>
        </div>
      </DialogStyledUpdate>
    </>
  );
};

export default LowBalancePopUp;
